exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#safety_social_tips_page > .container[data-v-38dea9b0] {\n  max-width: 600px;\n}\n#safety_social_tips_page > .container h2[data-v-38dea9b0] {\n    font-size: 20px;\n    font-weight: 400;\n    margin-top: 20px;\n    margin-bottom: 5px;\n}\n#safety_social_tips_page > .container ul[data-v-38dea9b0] {\n    margin-left: 30px;\n}\n#safety_social_tips_page > .container p[data-v-38dea9b0], #safety_social_tips_page > .container li[data-v-38dea9b0] {\n    margin-bottom: 5px;\n}\n", ""]);

// exports
